import React from 'react';

function CertificationIcon(): JSX.Element {
  return (
    <svg
      height='248.21'
      preserveAspectRatio='xMidYMid meet'
      version='1.1'
      viewBox='232 241.57142857142856 156.8571428571429 262.2051282051284'
      width='142.86'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <defs>
        <path
          d='M239 303.14L310.43 248.57L381.86 303.14L354.57 391.43L266.28 391.43L239 303.14Z'
          id='aZt9D86Ps'
        />
        <path
          d='M327.11 393.59L344.3 496.78L309.91 479.58L275.51 496.78L292.71 393.59L327.11 393.59Z'
          id='b7LyrCUAE'
        />
      </defs>
      <g>
        <g>
          <use
            fill='var(--primary-color)'
            fillOpacity='0'
            opacity='1'
            xlinkHref='#aZt9D86Ps'
          />
          <g>
            <use
              fillOpacity='0'
              opacity='1'
              stroke='var(--primary-color)'
              strokeOpacity='1'
              strokeWidth='14'
              xlinkHref='#aZt9D86Ps'
            />
          </g>
        </g>
        <g>
          <use
            fill='var(--primary-color)'
            fillOpacity='0'
            opacity='1'
            xlinkHref='#b7LyrCUAE'
          />
          <g>
            <use
              fillOpacity='0'
              opacity='1'
              stroke='var(--primary-color)'
              strokeOpacity='1'
              strokeWidth='14'
              xlinkHref='#b7LyrCUAE'
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

CertificationIcon.displayName = 'CertificationIcon';

export default CertificationIcon;
